@if (isLoading) {
  <div class="loading-overlay" aria-live="polite" aria-label="Signing you in">
    <div class="pulse-ring" aria-hidden="true"></div>
    <div class="loading-text">Signing you in&hellip;</div>
  </div>
}

<div class="login-page">

  <!-- Left: Red Gradient Hero Panel -->
  <div class="hero-panel">
    <div class="hero-panel__orb hero-panel__orb--1" aria-hidden="true"></div>
    <div class="hero-panel__orb hero-panel__orb--2" aria-hidden="true"></div>
    <div class="hero-panel__orb hero-panel__orb--3" aria-hidden="true"></div>

    <div class="hero-panel__content">
      <img src="assets/WatchGuard_Logo_Black_Red.png" alt="WatchGuard" class="hero-panel__logo" />
      <h1 class="hero-panel__title">WG Agents</h1>
      <p class="hero-panel__tagline">Your AI-powered workspace</p>

      <div class="hero-panel__features">
        <div class="hero-panel__feature">
          <i class="pi pi-microchip-ai"></i>
          <span>Intelligent AI Agents</span>
        </div>
        <div class="hero-panel__feature">
          <i class="pi pi-sitemap"></i>
          <span>Multi-department Coverage</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Right: Sign-in Card Panel -->
  <div class="card-panel">
    <div class="login-card">
      <div class="login-card__logo">
        <img src="assets/WatchGuard_Logo_Black_Red.png" alt="WatchGuard" />
      </div>

      <h2 class="login-card__heading">Welcome to <strong>WG Agents</strong></h2>
      <p class="login-card__subtext">Sign in with your Microsoft account to access your AI agents.</p>

      <button class="login-card__sso-btn" type="button" (click)="onLogin()" [disabled]="isLoading">
        <i class="pi pi-microsoft"></i>
        Sign in with Microsoft SSO
      </button>

      @if (errorText) {
        <div class="login-card__error" role="alert" aria-live="assertive">
          <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
          <span>{{ errorText }}</span>
        </div>
      }
    </div>
  </div>

</div>
